import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "toast-body" }

import { Toast } from 'bootstrap'
import { ref, onMounted, reactive } from 'vue'
import { ToastOptions } from './toastOptions';


export default /*#__PURE__*/_defineComponent({
  __name: 'ToastComponent',
  props: {
    toast: null
  },
  setup(__props: any) {

const props = __props as {
    toast: ToastOptions
}


const { toast } = reactive(props)

const toastEl = ref<Element | null>(null)
const bToast = ref<Toast | null>(null)

onMounted(() => {
    bToast.value = new Toast(toastEl.value!)
    bToast.value.show()
})

function dismiss() {
    bToast.value!.dispose()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref: refEl => { toastEl.value = refEl as Element },
    class: _normalizeClass(["toast align-items-center text-white border-0", {[`bg-${_unref(toast).type}`]: true}]),
    role: "alert",
    "aria-live": "assertive",
    "aria-atomic": "true"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(toast).message), 1),
      _createElementVNode("button", {
        type: "button",
        class: "button-close btn-close-white me-2 m-auto",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (dismiss())),
        "aria-label": "Close"
      })
    ])
  ], 2))
}
}

})